var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',{staticClass:"primary"},[_c('v-avatar',{attrs:{"size":"30px"}},[_c('img',{attrs:{"src":require('@/assets/images/button.png'),"alt":"INCHARGE"}})]),_c('v-toolbar-title',{staticClass:"white--text"},[_c('h4',[_vm._v("INCHARGE")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }